import { createApp } from 'vue'
import App from './App.vue'
import templatePlugin from "@/utils/template-plugin"
import router from './router'
import '@/assets/styles.scss'
//@ts-ignore
import JsonExcel from "vue-json-excel3"
import initMqtt from "@/utils/mqtt";

initMqtt()

createApp(App)
    .use(router)
    .use(templatePlugin)
    .component("downloadExcel", JsonExcel)
    .mount('#app')
